import Archive from './Archive.component';

export default Archive;
